import { compareByOrderHint } from "@ms/uno-utilities/lib/local/Comparators";
/**
 * Comparator for a descending sort based on orderhints
 * @param a Bucket on the left side of the comparison operation
 * @param b Bucket on the right side of the comparison operation
 */ export function compareByOrderHintDescending(a, b) {
    return compareByOrderHint(b, a, (bucket)=>bucket.orderHint);
}
